import React from 'react';
import Select, { SelectProps } from '@material-ui/core/Select';
import { FieldProps } from 'formik';

export interface FormikSelectProps extends FieldProps, Omit<SelectProps, 'name' | 'value'> {}

export function fieldToSelect({
    disabled,
    field,
    form: { isSubmitting },
    ...props
}: FormikSelectProps): SelectProps {
    return {
        disabled: disabled ?? isSubmitting,
        ...props,
        ...field,
    };
}

export default function FormikSelect(props: FormikSelectProps) {
    return <Select {...fieldToSelect(props)} />;
}
